import React from 'react';

type Props = {
  width?: string,
  height?: string,
  stroke?: string,
}

const Messages = ({ width, height, stroke }: Props) => (
  <svg
    id="prefix__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 48 48"
    width={width}
    height={height}
    transform="scale(1.3)"
  >
    <g id="prefix__g852">
      <path
        id="prefix__path8"
        d="M24.073 9.775h-8.185a7.882 7.882 0 00-7.872 7.882v2.156a7.871 7.871 0 005.36 7.474l.314.105-.168.282c-.429.744-1.047 1.905-1.78 3.549a.544.544 0 00.105.586.513.513 0 00.587.105l9.232-4.187h2.407a7.892 7.892 0 007.872-7.882v-2.188a7.892 7.892 0 00-7.872-7.882zM13.805 20.4a1.486 1.486 0 111.486-1.487 1.486 1.486 0 01-1.486 1.487zm6.155 0a1.486 1.486 0 111.486-1.487A1.486 1.486 0 0119.96 20.4zm6.154 0a1.486 1.486 0 111.487-1.487 1.476 1.476 0 01-1.434 1.487z"
        style={{
          fill: 'none',
          stroke,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          opacity: 1,
          strokeWidth: 2,
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          stopOpacity: 1,
        }}
      />
      <path
        id="prefix__path10"
        d="M19.373 31.914a.324.324 0 00-.062.554 7.798 7.798 0 004.647 1.529h2.376l9.232 4.187a.534.534 0 00.587-.116.523.523 0 00.094-.586c-.764-1.643-1.34-2.805-1.77-3.548l-.167-.283.314-.104a7.871 7.871 0 005.36-7.474v-2.104a7.892 7.892 0 00-5.83-7.61"
        style={{
          fill: 'none',
          stroke,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          opacity: 1,
          strokeWidth: 2,
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          stopOpacity: 1,
        }}
      />
    </g>
  </svg>
);

Messages.defaultProps = {
  stroke: '#000',
  width: 48,
  height: 48,
};

export default Messages;
